class DownloadContentUtiles {
    public static download(data: string, fileName: string, type: string) {
        var ieEDGE = navigator.userAgent.match(/Edge/g);
        var ie = navigator.userAgent.match(/.NET/g); // IE 11+
        var oldIE = navigator.userAgent.match(/MSIE/g);

        const byteCharacters = atob(data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var bytes = new Uint8Array(byteNumbers); //use this if data is raw bytes else directly pass resData
        var blob = new window.Blob([bytes], { type: type });

        if (ie || oldIE || ieEDGE) {
            //@ts-ignore
            window.navigator.msSaveBlob(blob, fileName);
        } else {
            var fileURL = URL.createObjectURL(blob);
            console.log(fileURL);
            var link = document.createElement('a');
            link.href = fileURL;
            link.download = fileName;
            link.target = '_blank';
            setTimeout(() => {
                document.body.appendChild(link);
                link.click();
            }, 50);
        }
    }
}

export default DownloadContentUtiles;
